import css from 'styled-jsx/css';

export default css`:global(.confirmDialog) :global(.confirmDialogPaperStyle) {
  max-width: 300px;
  margin-top: -48px; }
`